<div class="row member-documents nova-font-style">
  <div class="col s12 m10 offset-m1 l8 offset-l2 xl6 offset-xl3 remove-default-padding">
    <h2>Member Documents</h2>
    <div>
      <kendo-tabstrip [animate]="true" [tabAlignment]="'justify'">
        <kendo-tabstrip-tab title="Upload" [selected]="true">
          <ng-template kendoTabContent>
            <div class="row top-margin-15 nova-font-style member-doc-upload">
              <div class="col s12 m12 l12 xl12">
                <div>
                  <div class="row">
                    <span [innerHTML]="config.BatchIntro"></span>
                  </div>
                  <div class="row">
                    <kendo-chunkprogressbar class="full-width" [chunkCount]="chunkCount" [value]="value">
                    </kendo-chunkprogressbar>
                  </div>
                  <div class="row">
                    <kendo-upload #upload [multiple]="true" [autoUpload]="false" (remove)="removeEventHandler($event)"
                      (select)="onFileSelect($event)" [concurrent]="false" [restrictions]="fileRestrictions"
                      [withCredentials]="false" [disabled]="disableSubmitBtn" id="member-upload">
                    </kendo-upload>
                    <div *ngIf="allFiles.length > 0" class="row">
                      <div class="col s6 m6 l6 xl6 remove-default-padding">
                        <button kendoButton (click)="onClearButtonClick(upload)" class="full-width">Clear</button>
                      </div>
                      <div class="col s6 m6 l6 xl6 remove-default-padding">
                        <button kendoButton
                          [disabled]="errorMessages.length > 0 || maxFilesMessage || disableSubmitBtn || validationErrors"
                          (click)="uploadBatch(upload)" class="background-red full-width border-red text-white">
                          <span>Submit </span>
                          <span class="left-padding-5"
                            *ngIf="!(errorMessages.length > 0 || maxFilesMessage || disableSubmitBtn)">
                            {{allFiles.length > 0 ? allFiles.length + ' file(s)' : ''}}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="maxFilesMessage">
                    {{maxFilesMessage}}
                  </div>
                  <div *ngIf="errorMessages.length > 0">
                    <h4>Errors</h4>
                    <div class="totals-table error-messages-table">
                      <table>
                        <thead class="align-center color-white">
                          <tr>
                            <th>File Name</th>
                            <th>Pages</th>
                            <th>Error</th>
                          </tr>
                        </thead>
                        <tbody class="align-left">
                          <tr *ngFor="let message of errorMessages">
                            <td class="break-anywhere-overflow-wrap">{{message.fileName}}</td>
                            <td>{{message.pages}}</td>
                            <td>{{getValidationMessage(message.validationId)}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div *ngIf="show">
                    <app-notification-loading></app-notification-loading>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab title="History">
          <ng-template kendoTabContent>
            <app-upload-history [fileType]="'Member'"></app-upload-history>
          </ng-template>
        </kendo-tabstrip-tab>
      </kendo-tabstrip>
    </div>
  </div>
</div>
